<template>
  <div>
    <!-- 订单雷达页面 -->
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'ComponentName',
  
  props: [],
  data() {
    return {
     
    };
  },
  methods: {

  },
  mounted() {
    //
    
  },
  created(){
    // console.log(this.$route, '$router');
  }
};
</script>

<style lang="scss" scoped>
/* SCSS or CSS here */

</style>